import flatpickr from 'flatpickr';
import {Russian} from 'flatpickr/dist/l10n/ru';
import 'flatpickr/dist/flatpickr.css';

export default function () {
  const selector = '.js-datepicker';
  const list = document.querySelectorAll(selector);

  if (!list.length) return;

  flatpickr(list, {
    enableTime: true,
    dateFormat: 'd-m-Y H:i',
    time_24hr: true,
    locale: Russian
  });
}
